import { render, staticRenderFns } from "./TabLibraries.vue?vue&type=template&id=5cf7fa08&"
import script from "./TabLibraries.vue?vue&type=script&lang=js&"
export * from "./TabLibraries.vue?vue&type=script&lang=js&"
import style0 from "./TabLibraries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabLibraries.vue"
export default component.exports